import { render, staticRenderFns } from "./HtmlType.vue?vue&type=template&id=0f63f256&scoped=true&"
import script from "./HtmlType.vue?vue&type=script&lang=js&"
export * from "./HtmlType.vue?vue&type=script&lang=js&"
import style0 from "../../css/html.css?vue&type=style&index=0&id=0f63f256&scoped=true&lang=css&"
import style1 from "./HtmlType.vue?vue&type=style&index=1&id=0f63f256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63f256",
  null
  
)

export default component.exports